/**
 * Formats a duration in seconds to a string in the format DD:HH:MM:SS
 * @param totalSeconds The total duration in seconds
 * @returns A string in the format DD:HH:MM:SS
 */
export const formatDuration = (totalSeconds: number | undefined): string => {
  if (totalSeconds === undefined || isNaN(totalSeconds)) return '00:00:00:00';
  
  const days = Math.floor(totalSeconds / (24 * 3600));
  const hours = Math.floor((totalSeconds % (24 * 3600)) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = Math.floor(totalSeconds % 60);

  const d = days.toString().padStart(2, '0');
  const h = hours.toString().padStart(2, '0');
  const m = minutes.toString().padStart(2, '0');
  const s = seconds.toString().padStart(2, '0');

  return `${d}:${h}:${m}:${s}`;
};
